import { Box, useTheme } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import api from '../../service/api'
import { getCountString, Icons } from '../../utils/utilities'
import { Outlet, useSearchParams } from 'react-router-dom'
import TryAgainMessageBlock from '../../components/common/TryAgainMessageBlock'
import AuditPageHeader from '../../components/audit/AuditPageHeader'


const AuditClassSessions = () => {

    const [searchParams] = useSearchParams( { searchText: "", month: "", selectedDepartment: "all", selectedInstitute: "all", view: "tabular", sortByName: "1", sortBySubmissionsCount: "1", sortByAssignmentCount: "1" } )
    const selectedInstitute = searchParams.get( 'selectedInstitute' ) || "all"
    const selectedDepartment = searchParams.get( 'selectedDepartment' ) || "all"

    const [error, setError] = useState( false )
    const [counts, setCounts] = useState( {} )
    const [loading, setLoading] = useState( true )

    const { layout } = useTheme()

    const getData = useCallback( async () => {
        try {
            setLoading( true )
            const department = selectedDepartment !== "all" ? selectedDepartment : ""
            const institute = selectedInstitute !== "all" ? selectedInstitute : ""
            const { data: { data: counts } } = await api.audit.getClassSessionsCounts( { last30dayscount: true, institute, department } )
            setCounts( counts )
            setError( null )
        } catch ( err ) {
            setError( { code: err?.response?.status, message: err?.response?.data?.message || "Something went wrong while fetching the class sessions audit data." } )
        } finally {
            setLoading( false )
        }
    }, [selectedInstitute, selectedDepartment] )


    useEffect( () => {
        getData()
    }, [getData] )


    return (
        <Box padding={layout.pagePadding} display="flex" flexDirection="column" gap={layout.sectionsGap} overflow="auto" flexGrow={1}>

            {/* Header */}
            <AuditPageHeader
                loading={loading}
                title="Quizzes Audit"
                subtitle="View all quizzes activities here."
                countCards={[
                    {
                        icon: Icons.default.Class,
                        label: "Class Session",
                        value: getCountString( counts.totalLiveSessionCount ),
                        secondary: getCountString( counts.last30daysCount ),
                        secondaryLabel: "In last 30 days"
                    },
                    {
                        icon: Icons.default.FilePresent,
                        label: "Resources Linked",
                        value: getCountString( counts.totalLiveSessionResourcesCount ),
                        secondary: getCountString( counts.last30daysResourcesCount ),
                        secondaryLabel: "In last 30 days"
                    },
                    {
                        icon: Icons.default.Archive,
                        label: "Unused Resources",
                        value: getCountString( counts.unusedResourcesCount ),
                        secondary: "",
                        secondaryLabel: "Dangling resources"
                    },
                ]}
            />

            {error && <Box sx={{ padding: "20px", flexShrink: 0 }}>
                <TryAgainMessageBlock getData={getData} err={error.message} code={error.code} loading={loading} />
            </Box>}
            <Outlet />
        </Box >
    )
}

export default AuditClassSessions
